<template>
  <div class="insertTokenInstructions">
    <p>
      Insira o código enviado para o
      <template>{{contactTypeName}}</template>
      <br>
      <span class="insertTokenInstructions__contact">
        <template>{{contactValue}}</template>
      </span>
      , para validar sua identidade.
    </p>
  </div>

</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'InsertTokenInstructions',
  props: {
    contactType: {
      type: String,
      default: 'sms',
    },
  },

  computed: {
    ...mapState({
      contactSelected: ({ validation }) => validation.data.contactSelected,
    }),

    contactTypeName() {
      const contactTypeName = this.contactType === 'sms'
        ? 'número'
        : 'email';

      return contactTypeName;
    },

    contactValue() {
      const contactValue = this.contactSelected?.maskedValue;

      return contactValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.insertTokenInstructions {
  display: flex;
  flex-direction: row;
  width: 100%;

  p {
    font-size: var(--font-size-2);
    line-height: 1.5;
    margin: 48px 0 24px;
    width: 100%;

    @media (min-width: 321px) {
      font-size: var(--font-size-3);
    }
  }

  &__contact {
    color: var(--color-primary);
    margin-bottom: 10px;
  }
}
</style>
